import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-delete-confirmation-popup',
  templateUrl: './delete-confirmation-popup.component.html',
  styleUrls: ['./delete-confirmation-popup.component.scss']
})
export class DeleteConfirmationPopupComponent {

  @ViewChild('deleteMenuItemModal') deleteConfirmationTemplate!: TemplateRef<DeleteConfirmationPopupComponent>;
  @Input() id: number;
  @Input() imageId:number;
  @Input() dishName:string;
  @Output() menuDeleted = new EventEmitter<number>();

  constructor(private userService:UserService, private loaderService:LoaderService, private toastr:ToastrService){}

  deleteDish(productId:number, imageId:number){
    if(imageId != undefined && imageId != 0){
      this.deleteProductImage(productId, imageId);
    }
    this.deleteProduct(productId);
    this.menuDeleted.emit(productId);
  }

  deleteProduct(productId:number){
    this.loaderService.setLoading(true);
    this.userService.delete(`api/inventory/products`, productId)
    .pipe(
      catchError((error)=>{
        if (error.status == 404) {
          throw error;
        } else {
          this.loaderService.setLoading(false);
          throw error;
        }
      })
    )
    .subscribe((response)=>{
      this.toastr.success('Dish deleted successfully!');
      this.loaderService.setLoading(false);
    });
  }

  deleteProductImage(productId:number, imageId:number){
    this.loaderService.setLoading(true);
    this.userService.delete(`api/bliss/blissProduct/removeImage/${productId}`, imageId)
    .pipe(
      catchError((error)=>{
        if (error.status == 404) {
          throw error;
        } else {
          this.loaderService.setLoading(false);
          throw error;
        }
      })
    )
    .subscribe((response)=>{
      this.toastr.success('Dish Image deleted successfully!');
      this.loaderService.setLoading(false);
    });
  }
}
